import React, {PropTypes} from 'react';
import {Button} from '@goguardian/based';

import AssociateLead from '_shared/components/associateLead';

import style from './style.scss';

export default class ThankYou extends React.Component {

  toHomePage() {
    window.location = 'https://www.goguardian.com';
  }

  render() {
    return (
      <div className={style.tyContainer}>
        <h1>Thanks for your interest!</h1>
        <p>We'll contact your IT Administrator to see how they want to proceed.
        You can follow up with them directly if you have any questions about sign-up.</p>
        <Button onClick={this.toHomePage}>
          Return to homepage
        </Button>
        <AssociateLead />
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/thankYou/index.jsx
 **/